import { ElementType, lazy } from 'react'

export interface Route {
  path: string
  isPublic?: boolean
  restricted?: boolean
  component: ElementType
}
const profileEnabled = import.meta.env.VITE_PROFILE_ENABLED === 'true'
const routes: Route[] = [
  {
    path: '/',
    isPublic: true,
    restricted: true,
    component: lazy(() => import('../views/Login'))
  },
  {
    path: '/login',
    isPublic: true,
    restricted: true,
    component: lazy(() => import('../views/Login'))
  },
  {
    path: '/report',
    isPublic: false,
    component: lazy(() => import('../views/Report'))
  },
  {
    path: '/dashboard',
    isPublic: false,
    component: lazy(() => import('../views/Dashboard'))
  },
  {
    path: '/evaluation-rb',
    isPublic: false,
    component: lazy(() => import('../views/EvaluationRB'))
  },
  {
    path: '/tasks',
    isPublic: false,
    component: lazy(() => import('../views/Tasks'))
  },
  {
    path: '/cases',
    isPublic: false,
    component: lazy(() => import('../views/Cases'))
  },
  {
    path: '/cases/new',
    isPublic: false,
    component: lazy(() => import('../views/CaseCreate'))
  },
  {
    path: '/cases/new-legal-advice',
    isPublic: false,
    component: lazy(() => import('../views/CreateLegalAdvice'))
  },
  {
    path: '/cases/:id',
    isPublic: false,
    component: lazy(() => import('../views/Case'))
  },
  {
    path: '/cases/:id/processing/:processingId',
    isPublic: false,
    component: lazy(() => import('../views/Case'))
  },
  {
    path: '/cases-creator/',
    isPublic: false,
    component: lazy(() => import('../views/Cases/CreatorCasesEditable'))
  },
  {
    path: '/pools/:slug',
    isPublic: false,
    component: lazy(() => import('../views/Pool'))
  },
  {
    path: '/cases-creator/:id',
    isPublic: false,
    component: lazy(() => import('../views/CaseCreator'))
  },
  {
    path: '/feedbacks',
    isPublic: false,
    component: lazy(() => import('../views/Feedbacks'))
  },
  {
    path: '/payouts',
    isPublic: false,
    component: lazy(() => import('../views/Payouts'))
  },
  {
    path: '/received-emails',
    isPublic: false,
    component: lazy(() => import('../views/ReceivedEmails'))
  },
  {
    path: '/einsatzplanung',
    isPublic: false,
    component: lazy(() => import('../views/Einsatzplanung'))
  },
  {
    path: '/unassigned-emails',
    isPublic: false,
    component: lazy(() => import('../views/UnassignedEmails'))
  },
  {
    path: '/my-emails',
    isPublic: false,
    component: lazy(() => import('../views/MyEmails'))
  },
  {
    path: '/notifications',
    isPublic: false,
    component: lazy(() => import('../views/Notifications'))
  },
  ...(profileEnabled
    ? [
        {
          path: '/profile',
          isPublic: false,
          component: lazy(() => import('../views/UserProfile'))
        }
      ]
    : []),
  {
    path: '*',
    isPublic: false,
    component: lazy(() => import('../views/NotFound'))
  }
]

export default routes
